export function formatNumber(num: any) {
  // return new Intl.NumberFormat("fr-FR").format(num);
  // "fr-FR" uses space as thousands separator
  return new Intl.NumberFormat("en-US").format(num);
  // "fr-FR" uses comma as thousands separator
}
